import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '@nstep-common/core';
import { EntitlementTypeDto, UnrationedBalanceModel } from '@nstep-public/pages';

@Injectable({
	providedIn: 'root'
})
export class PosOperatorService {
	constructor(private apiService: ApiService) {
	}

	getCardEntitlements(cardNumber: string): Observable<UnrationedBalanceModel> {
		return this.apiService.get(UnrationedBalanceModel, `pos-operator/${cardNumber}`);
	}

	getEntitlementTypes(ids: number[]): Observable<EntitlementTypeDto[]> {
		return this.apiService.post([EntitlementTypeDto], 'pos-operator/entitlement-types', ids);
	}
}
